import { Inject, Injectable, Injector, Renderer2, RendererFactory2 } from '@angular/core';
import { GlobalService } from 'app/global/global.service';
import feather from 'feather-icons';
import { Subscription, delay, of, take } from 'rxjs';
import uuid from 'short-unique-id';
import { PopOver } from '../popover/popover';
import { TranslocoService } from '@jsverse/transloco';
import { Type } from 'app/global/tiptap-editor/slash-command/command-type-enum';
import { ElementPosition } from '../content-tab/content-tab.dto';
import { SessionImageService } from 'app/global/session-image.service';
import { DroplistOptions } from 'app/interfaces/fields';

@Injectable({
    providedIn: 'root',
})
export class formBuilder {
    private renderer:Renderer2
    public instance_name:string = '';
    public uuid = new uuid({ length: 6, dictionary: 'number' });
    public keydownCount:number = 0;
    public selectMenuIsOpen:boolean = false;
    public timeOutSubscription: Subscription;
    /**
     * 
     * @param {injector} injector 
     */
    constructor(@Inject(Injector) private readonly injector: Injector, private _translocoService:TranslocoService, rendererFactory:RendererFactory2, private sessionImageService:SessionImageService) {
        this.renderer = rendererFactory.createRenderer(null, null);
    }

    private allowedSelf(){
        return this;
    }

    /**
     * return the text form for form builder box
     * @param params 
     */
    textFormBuilderHtml(params) {
        return `
        <div contenteditable="false" class="form-builder-table drag-fields" uuid="${params.uuid}" field_required="1" field_fontsize="14" slashcommandtable="1" column="50">
            <div class="custum-form-builder-box fields-ele-container">
                <label class="custum-form-builder-label selected-label">${this._translocoService.translate("Content new field (Template/Document - section) - Field name - New field")}</label>
                <input class="custum-form-builder-field form-control form-builder-field-label text-field-input" type="text" placeholder="">
                <textarea class="hidden text-field-textarea form-control" placeholder="${this._translocoService.translate("Content new field (Template/Document - section) - Field name - New field")}"></textarea>
            </div>
        </div>
     `;
    }

    /**
     * return the datepikcer form for form builder box
     * @param params 
     */
    datepickerFormBuilderHtml(params) {
        return `
        <div contenteditable="false" class="form-builder-table drag-fields" uuid="${params.uuid}" field_required="1" field_fontsize="14" slashcommandtable="1" column="50">
            <div class="custum-form-builder-box fields-ele-container">
                <label class="custum-form-builder-label selected-label">${this._translocoService.translate("Content new field (Template/Document - section) - Field name - New field")}</label>
                <input class="custum-form-builder-field form-control form-builder-field-label datepicker-field" type="text" placeholder="">
            </div>
        </div>
        `;
    }

    /**
     * return the checkbox form for form builder box
     * @param params 
     */
    checkboxFeildFormBuilderHtml(params) {
        return `<div class="form-builder-table checkbox-field drag-fields" uuid="${params.uuid}" field_required="1" field_fontsize="14" column="100">
                <div class="drag-fields-inner-container checkbox-field-inner-container fields-ele-container">
                    <div class="checkbox-field-box">
                        ${feather.icons.check.toSvg({ class: 'cursor-pointer checkbox-checkIcon', width: 14, height: 14 })}
                    </div>
                    <span class="field-label checkbox-field-label selected-label">${this._translocoService.translate("Content new field (Template/Document - section) - Field name - New field")}</span>
                </div>
            </div>
        `;
    }

    /**
     * return the droplist form for form builder box
     * @param params 
     */
    droplistFeildFormBuilder(params) {
        const uuid = params.uuid;
        return `<div class="form-builder-table droplist-field drag-fields" uuid="${uuid}" field_required="1" field_fontsize="14" column="50">
                <div class="drag-fields-inner-container droplist-field-inner-container fields-ele-container">
                    <span class="custum-form-builder-label field-label selected-label">${this._translocoService.translate("Content droplist select option (Template/Document - section) - Select option")}</span>
                    <div class="droplist-inner-box droplist-menu">
                        <span class="selected-option-label droplist-option-label form-builder-field-label" droplistplaceholder="${this._translocoService.translate("Content droplist select option (Template/Document - section) - Select option")}"></span>
                        ${feather.icons['chevron-down'].toSvg({ class: 'cursor-pointer droplist-arrowDown', width: 14, height: 14 })}
                        <ng-dropdown-panel role="listbox" aria-label="Options list" class="ng-dropdown-panel ng-select-bottom droplist-dropdown hidden">
                            <div class="ng-dropdown-panel-items scroll-host">
                                <div class="ng-dropdown-header hidden">
                                    <input type="text" class="form-control w-100 search-drop-value" uuid="${uuid}">
                                </div>
                                <div class="ng-dropdown-custom-options"></div>
                            </div>
                        </ng-dropdown-panel>
                    </div>
                </div>
                </div>
            </div>
        `;
    }
    /**
     * return the multi choice form for form builder box
     * @param params 
     */
    multiChoiceFeildFormBuilder(params) {
        const uuid = params.uuid;
        let options = '';
        for (const option of params.options) {
            options += `
                        <div class="multiChoice-item" option_uuid="${option.id}">
                            <div class="multiChoice-box">
                                <div class="multiChoice-inner-circle"></div>
                                ${feather.icons.check.toSvg({ class: 'cursor-pointer multiChoice-inner-check', width: 14, height: 14 })}
                            </div>
                            <label class="multiChoice-label-text">${option.name}</label>
                        </div>`;
        }
        return `<div class="form-builder-table multichoice-field multiChoice-radio drag-fields" uuid="${uuid}" field_required="1" field_fontsize="14" column="50">
                    <div class="custum-form-builder-box">
                        <span class="custum-form-builder-label field-label selected-label">${this._translocoService.translate("Content droplist select option (Template/Document - section) - Select option")}</span>
                        <div class="multiChoice-item-container fields-ele-container">
                            ${options}
                        </div>
                    </div>
                </div>
            `;
    }
    
    /**
     * return the signature form for form builder box
     * @param params 
     */
    signatureFeildFormBuilder(params) {
        return `<div class="form-builder-table signature-field drag-fields" uuid="${params.uuid}" field_required="1" field_fontsize="14" column="100">
                <div class="drag-fields-inner-container signature-field-inner-container fields-ele-container">
                    <span class="field-label selected-label cursor-pointer pe-auto hidden}">${this._translocoService.translate("Content block html text on signature box (Template/Document - section) - Click to add your signature")}</span>
                    <div class="signature-image" style="background-image:url(});"></div>
                    <span class="assignee"></span>
                </div>
            </div>
        `;
    }

    /**
     * return the form builder box
     * @param params 
     */
    formBuilderBox(params,callback?:({form_uuid,textfield_uuid})=>void) {
        const that = this.allowedSelf();
        const uuid = this.uuid();
        const textFormUuid = this.uuid();
        const buildForm = that.textFormBuilderHtml({ uuid: textFormUuid, parentdiv: 1 });
        const formBuilderElement = document.createElement('div');
        formBuilderElement.className = 'content-box content-box-block form-builder-block marginminus70';
        formBuilderElement.innerHTML = `<div class="sort-helper">
        </div><div class="content-box-row"><div class="rowItem formbuilderblock">${that.popOverFunc.listingPopover({classType:'form-builder',uuid:uuid,contentType:'settings'})}<div class="content-box-inner" editor-uuid="${uuid}" type="form"><div class="editor${uuid} cke-editor-placeholder cke-editor-box form-builder" editor-uuid="${uuid}" ><div class="form-builder-parent-container" contenteditable="false">${buildForm}</div></div></div></div></div>`;

        if (!document.querySelector('.dropIndicator-bottom') && document.querySelector('.template-page')?.classList.contains('addContentBox')) {
            this.renderer.appendChild(document.querySelector('.template-page'), formBuilderElement);
        } else if (params.editor && params.type === Type.FormBuilder) {
            this.renderer.insertBefore(
                params.editor.view.dom.closest('.content-box').parentNode, 
                formBuilderElement, 
                params.editor.view.dom.closest('.content-box').nextSibling
            );
        } else {
            const dropIndicatorBottomParent = document.querySelector('.dropIndicator-bottom')?.closest('.content-box');
            if(params?.position === ElementPosition.Top) {
                this.renderer.insertBefore(dropIndicatorBottomParent.parentNode, formBuilderElement, dropIndicatorBottomParent);
            }else{
                this.renderer.insertBefore(dropIndicatorBottomParent.parentNode, formBuilderElement, dropIndicatorBottomParent.nextSibling);
            }
        }
        that.GlobalServiceFunc.contentBoxSort();
        this.timeOutSubscription = of(null).
            pipe(
                delay(200),
                take(1)
            ).subscribe(() => {
                document.querySelector('.editor' + uuid).closest('.content-box-inner').classList.add('active-border');
            });
        if(this.timeOutSubscription){
            this.timeOutSubscription.unsubscribe();
        }

        if(callback){
            callback({form_uuid:uuid,textfield_uuid:textFormUuid})        
        }
    }

    /**
     * injector for the global services
     */
    private get GlobalServiceFunc() {
        return this.injector.get(GlobalService);
    }

    /**
     * injector for the popover services
     */
    private get popOverFunc(){
        return this.injector.get(PopOver);
    }

    addFormBuilderField(params: { uuid?: string, type?:string,  options?:DroplistOptions[], formBuilderUuid?: string | number } = {}, callback:(uuid)=>void){
        const view = this.viewRoute(params.type, params.uuid, params.options);
        const formBuilderSelector = document.querySelector(`.editor${params.formBuilderUuid}`)?.querySelector('.form-builder-parent-container');
        if (!formBuilderSelector) return;
        const fieldElement = this.fieldBlock(view);
        if (fieldElement) {
            this.renderer.appendChild(formBuilderSelector, fieldElement);
        }
        if (callback) {
            callback(params.uuid);
        }
    }

    fieldBlock(view: string): HTMLElement {
        const element = document.createElement('div');
        element.innerHTML = view.trim();
        return element.firstElementChild as HTMLElement;
    }

        /**
     * return the view bsae on viewname
     * @param viewname
     * @param uuid
     * @param options
     */
    viewRoute(viewname: string, uuid: string, options: DroplistOptions[]) {
        let view = '';
        switch (viewname) {
            case 'text':
                view = this.textFormBuilderHtml({ uuid: uuid });
                break;
            case 'datepicker':
                view = this.datepickerFormBuilderHtml({ uuid: uuid });
                break;
            case 'checkbox':
                view = this.checkboxFeildFormBuilderHtml({ uuid: uuid });
                break;
            case 'droplist':
                view = this.droplistFeildFormBuilder({ uuid: uuid });
                break;
            case 'multichoice':
                view = this.multiChoiceFeildFormBuilder({ uuid: uuid, options:options });
                break;
            case 'signature':
                view = this.signatureFeildFormBuilder({ uuid: uuid });
                break;
        }
        return view;
    }
}
